const LIGHTNESS_THRESHOLD = 50;
export function isValidHexCode(hexColor) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(hexColor);
}
export function hexToInt(part) {
    return parseInt(part, 16);
}
export function rgbPartToDecimal(part) {
    return part / 255;
}
export function hexToRGB(hexColor) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
    if (result === null || result.length < 3) {
        throw new Error('Invalid hex code used as input');
    }
    return {
        red: hexToInt(result[1]),
        green: hexToInt(result[2]),
        blue: hexToInt(result[3]),
    };
}
export function getLightnessFromRgbCode(rgb) {
    const dRed = rgbPartToDecimal(rgb.red);
    const dGreen = rgbPartToDecimal(rgb.green);
    const dBlue = rgbPartToDecimal(rgb.blue);
    const max = Math.max(dRed, dGreen, dBlue);
    const min = Math.min(dRed, dGreen, dBlue);
    let lightness = (max + min) / 2;
    lightness *= 100;
    return Math.round(lightness);
}
export function isDarkColor(hexColor) {
    if (hexColor === undefined || !isValidHexCode(hexColor)) {
        return false;
    }
    const rgb = hexToRGB(hexColor);
    const lightness = getLightnessFromRgbCode(rgb);
    return lightness < LIGHTNESS_THRESHOLD;
}
